export default function handleVideoPopup() {
  const selectors = {
    modals: '[data-gallery-modal]',
    overlay: '[data-overlay]',
  }

  const modals = document.querySelectorAll<HTMLElement>(selectors.modals);
  const overlay = document.querySelector(selectors.overlay);

  if (modals.length === 0) return;

  const hidePopup = (el: HTMLIFrameElement) => {
    el.parentElement.parentElement.classList.add('hidden');
  }

  const pauseVideo = (el: HTMLIFrameElement) => {
    el.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    hidePopup(el);
  }

  const hideOverlay = (el: HTMLIFrameElement) => (e: any) => {
    overlay.classList.remove('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
    pauseVideo(el);
  }

  const showOverlay = (el: HTMLIFrameElement) => {
    overlay.classList.add('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');

    overlay.addEventListener('click', hideOverlay(el));
  }

  const showPopup = (e: any) => {
    const target = e.target;
    const galleryItem = target.closest('li');
    const iframe = galleryItem.querySelector('iframe');
    const closeIcon = iframe.parentElement.parentElement.querySelector('button');


    iframe.src = iframe.dataset.src;
    iframe.parentElement.parentElement.classList.remove('hidden');

    closeIcon.addEventListener('click', hideOverlay(iframe));
    showOverlay(iframe);
  }

  modals.forEach((modal: HTMLButtonElement) => {
    modal.addEventListener('click', showPopup);
  });
}

handleVideoPopup();
